import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useParticipantCount(eventId: string) {
  const [participantCount, setParticipantCount] = useState(0);
  const [loading, setLoading] = useState(true);

  console.log('useParticipantCount - Hook initialized with eventId:', eventId);

  const fetchParticipantCount = useCallback(async () => {
    if (!eventId) {
      setParticipantCount(0);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const { count, error } = await supabase
        .from('registrations')
        .select('*', { count: 'exact', head: true })
        .eq('event_id', eventId)
        .eq('status', 'confirmed');

      if (error) throw error;
      console.log('useParticipantCount - Query result:', { eventId, count, error: null });
      setParticipantCount(count || 0);
    } catch (err) {
      console.error('Error fetching participant count:', { eventId, err });
      setParticipantCount(0);
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    fetchParticipantCount();
  }, [fetchParticipantCount]);

  return {
    participantCount,
    loading,
    refetch: fetchParticipantCount
  };
}